import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EmailVerificationType } from 'queries';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  mail: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  signIn: { marginTop: '5vh' },
  headingBox: { textAlign: 'center' },
}));

type Props = {
  verificationType: EmailVerificationType;
};

const Banner = ({ verificationType }: Props) => {
  const classes = useStyles();

  const title = getTitle();
  const description = getDescription();

  function getTitle() {
    let title = '';

    switch (verificationType) {
      case EmailVerificationType.UserRegistration:
        title = 'Verify your email to login';
        break;

      case EmailVerificationType.UserPortalInvitationNewUser:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationNewUser is not supported through the UI',
        );

      case EmailVerificationType.UserPortalInvitationExistingUser:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationExistingUser is not supported through the UI',
        );

      case EmailVerificationType.UserPortalInvitationNewClient:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationNewClient is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruadmin:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruadmin is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruplanning:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruplanning is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruproxy:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruproxy is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTrustadmin:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTrustadmin is not supported through the UI',
        );

      default:
        title = 'Invalid verification type';
        break;
    }

    return title;
  }

  function getDescription() {
    let description = '';

    switch (verificationType) {
      case EmailVerificationType.UserRegistration:
        description =
          'Enter your email address and we will send you a link with a verification code';
        break;

      case EmailVerificationType.UserPortalInvitationNewUser:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationNewUser is not supported through the UI',
        );

      case EmailVerificationType.UserPortalInvitationExistingUser:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationExistingUser is not supported through the UI',
        );

      case EmailVerificationType.UserPortalInvitationNewClient:
        throw new Error(
          'EmailVerificationType.UserPortalInvitationNewClient is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruadmin:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruadmin is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruplanning:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruplanning is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTruproxy:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTruproxy is not supported through the UI',
        );

      case EmailVerificationType.EstateClientConsentTrustadmin:
        throw new Error(
          'EmailVerificationType.EstateClientConsentTrustadmin is not supported through the UI',
        );

      default:
        description = 'Invalid verification type';
        break;
    }

    return description;
  }

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      <img src={'/mail.svg'} alt="Trustate Products" className={classes.mail} />
      <div className={classes.signIn}>
        <Typography variant="h4" style={{ marginBottom: '15px' }}>
          {title}
        </Typography>
        <Typography style={{ display: 'inline', paddingLeft: '10px', paddingRight: '10px' }}>
          {description}
        </Typography>{' '}
      </div>
    </div>
  );
};

export default Banner;
